import * as Users from './users';
import * as Roles from './roles';
import * as Customers from './customers';
import Config from './users-and-access.router';
import options from './users-and-access.component';

const Component = {
    selector: 'dtUsersAndAccess',
    options
};

export {
    Users,
    Roles,
    Customers,
    Config,
    Component
};



// WEBPACK FOOTER //
// ./app/components/users-and-access/index.js